module.exports = __webpack_public_path__ + "static/media/ErinFox.42793944.jpg";